export default "/images/vendor/flag-icon-css/flags/1x1/py.svg?b19bb0ae9ad5d553a146f088ed6fa4a0";